import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Film, X } from 'lucide-react';

/**
 * "What's new": sample videos for doc edits and social media videos in the Style Profile, for CLIENTS whose profile
 * covers video (operator, 2026-09-26). The wording is the operator's, word for word. One decision on the screen: add
 * samples, or not now.
 *
 * It blocks nobody, so every way out marks it seen, as the referral notice does: the two buttons, the X, and the
 * backdrop (`dismissOnBackdrop`). "Add samples" marks it seen and goes straight to the new spots on the Style Profile
 * (StyleProfilePage.js, #more-samples).
 */
export const SAMPLES_TARGET = '/style-profile#more-samples';

export function SamplesPerProductAnnouncement({ onAcknowledge }) {
  const navigate = useNavigate();
  const seen = () => onAcknowledge && onAcknowledge();
  const addSamples = async () => { await seen(); navigate(SAMPLES_TARGET); };
  return (
    <div className="relative w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-2xl bg-ug-raised border border-ug-border shadow-2xl"
         data-testid="whats-new-samples-per-product">
      <button type="button" onClick={seen} data-testid="whats-new-close" aria-label="Close"
              className="tap-auto absolute top-4 right-4 w-7 h-7 rounded-full flex items-center justify-center text-slate-500 hover:text-zinc-100 hover:bg-white/[0.06]">
        <X className="w-3.5 h-3.5" strokeWidth={2} />
      </button>
      <div className="p-6 pb-5 border-b border-ug-border-subtle">
        <div className="flex items-center gap-2 mb-3">
          <Film className="w-3.5 h-3.5 text-ug-gold" strokeWidth={2} />
        </div>
        <h2 className="font-heading text-2xl text-zinc-100 pr-8">Show us what you like for every kind of video</h2>
      </div>
      <div className="p-6 py-5">
        <p className="text-[14px] text-zinc-100/80 leading-relaxed" data-testid="whats-new-samples-body">
          You can now add sample videos for doc edits and social media videos, not just highlight films. Your editor uses them to match your style on each one.
        </p>
      </div>
      <div className="p-6 pt-5 border-t border-ug-border-subtle bg-ug-surface/20 flex flex-col sm:flex-row gap-2">
        <button data-testid="whats-new-next" onClick={addSamples}
                className="tap-auto flex-1 py-2.5 rounded-lg bg-gold-leaf text-obsidian font-sans text-[11px] font-semibold uppercase tracking-wider">
          Add samples
        </button>
        <button data-testid="whats-new-not-now" onClick={seen}
                className="tap-auto flex-1 py-2.5 rounded-lg border border-ug-border text-zinc-100/80 hover:text-zinc-100 hover:bg-white/[0.04] font-sans text-[11px] font-semibold uppercase tracking-wider">
          Not now
        </button>
      </div>
    </div>
  );
}
SamplesPerProductAnnouncement.dismissOnBackdrop = true;

export default SamplesPerProductAnnouncement;
